import { AppEnv } from '@shared/data-access/app-config';

import { ENVIRONMENT_URLS } from './environment-urls';

export const environment: AppEnv = {
  production: false,
  ...ENVIRONMENT_URLS.acc,
};
